module.exports = globalThis.L;